import axios from "axios";
import { getIdToken } from "../Auth/Auth";

const SAVE_RECORDING = "save_agent_recording";
const GET_AGENT_RECORDINGS = "get_agent_recordings";
const GET_RECORDING_TYPES = "get_recording_types";

export const getRecordingTypes = () =>
  axios.post(
    `${process.env.REACT_APP_RECORDER_SERVICE_BASE_URL}/${GET_RECORDING_TYPES}`,
    {},
    {
      headers: { Authorization: `Bearer ${getIdToken()}` }
    }
  );

export const getAgentRecordings = () =>
  axios.post(
    `${process.env.REACT_APP_RECORDER_SERVICE_BASE_URL}/${GET_AGENT_RECORDINGS}`,
    {},
    {
      headers: { Authorization: `Bearer ${getIdToken()}` }
    }
  );

export const saveRecording = recording =>
  axios.post(`${process.env.REACT_APP_RECORDER_SERVICE_BASE_URL}/${SAVE_RECORDING}`, recording, {
    headers: { Authorization: `Bearer ${getIdToken()}` }
  });
